<template>
  <div class="live-form">
    <div class="info-content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
      >
        <base-title :title="`基本信息`"></base-title>
        <el-form-item label="直播名称：" prop="course_name">
          <el-input v-model="ruleForm.course_name" placeholder="请输入课程名称"></el-input>
        </el-form-item>

        <el-form-item label="副标题：" prop="times">
          <el-input v-model="ruleForm.times" placeholder="请输入课程副标题"></el-input>
        </el-form-item>

        <el-form-item label="直播时间：" prop>
          <el-form-item label="开始时间" prop="started_at" class="iblock" label-width="100px">
            <el-date-picker
              :disabled="isEdit&&(live_state)"
              v-model="ruleForm.started_at"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="直播时长" prop="course_duration" class="iblock">
            <el-select v-model="ruleForm.course_duration"
             placeholder="直播时长"
             :disabled="isEdit&&(live_state)"
             @change="getDuration">
              <el-option
                v-for="(item,index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="课程图片：">
          <div class="upload-image">
            <upload-cover
              tips="图片尺寸为750*424，JPG、PNG格式；图片用在首页banner、课程详情页、直播间"
              img_height="98"
              :autoSize="750/424"
              @uploadSuccess="uploadCourse"
              :coverImg="ruleForm.course_cover"
            ></upload-cover>

            <upload-cover
              img_height="98"
              :autoSize="686/260"
              tips="图片尺寸为686*260，JPG、PNG格式；图片用在首页直播中"
              @uploadSuccess="uploadLive"
              :coverImg="ruleForm.live_cover"
            ></upload-cover>

            <upload-cover
              img_height="98"
              :autoSize="686/260"              
              tips="图片尺寸为686*260，JPG、PNG格式；图片用在专题-课程页"
              @uploadSuccess="uploadPub"
              :coverImg="ruleForm.publicity_cover"
            ></upload-cover>

            <upload-cover
              img_height="98"
              :autoSize="666/642"
              tips="图片尺寸为666*632，JPG、PNG格式；图片用在生成卡片"
              @uploadSuccess="uploadCard"
              :coverImg="ruleForm.card_cover"
            ></upload-cover>

          </div>
        </el-form-item>
        <el-row class="teachers-info">
          <el-form-item label="课程讲师：">
            <div class="teachers-wrapper" v-for="(item,index) in ruleForm.teachers" :key="index">
              <div class="iblock l">
                <el-form-item
                  label="讲师姓名："
                  :prop="`teachers.${index}.teacher_name`"
                  :rules="[{validator: teachers_info, trigger: 'blur', required: true}]"
                >
                  <el-input
                    type="text"
                    class="w300"
                    v-model="item.teacher_name"
                    placeholder="请输入讲师姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="讲师Title："
                  :prop="`teachers.${index}.teacher_title`"
                  :rules="[{validator: teachers_info, trigger: 'blur', required: true}]"
                  class="mt20"
                >
                  <el-input
                    type="text"
                    class="w300"
                    v-model="item.teacher_title"
                    placeholder="请输入讲师Title"
                  ></el-input>
                </el-form-item>
              </div>

              <div class="cover iblock r">
                <div class="img" v-if="item.teacher_pfrofile_photo">
                  <div class="img-shadow">
                    <i class="el-icon-crop deal-item" title="裁剪" @click="PhotoCrop(index)"></i>
                    <i class="el-icon-delete deal-item" title="删除" @click="PhotoDel(index)"></i>
                  </div>
                  <i class="el-icon-loading" v-if="typeof item.teacher_pfrofile_photo != 'string'"></i>
                  <img v-else :src="item.teacher_pfrofile_photo" alt />
                </div>

                <div class="upload-btn-wrap">
                  <el-upload
                    class="upload-demo"
                    action="/admin/upload/image"
                    accept="image/*"
                    name="imageFile"
                    :show-file-list="false"
                    :before-upload="uploadWxBefore"
                    :on-error="uploadWxError"
                    :on-success="uploadWxSuccess"
                  >
                      <div class="cover-box" v-if="!item.teacher_pfrofile_photo" @click="getImageIndex(index)">
                        <i class="el-icon-plus"></i>
                        <!-- <span>添加头像</span> -->
                    </div>
                  </el-upload>
                </div>
              </div>

              <el-form-item
                label="讲师简介："
                :prop="`teachers.${index}.teacher_introduction`"
                :rules="[{validator: teachers_info, trigger: 'blur', required: true}]"
                class="mt20 clearfix"
              >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 8}"
                  v-model="item.teacher_introduction"
                  placeholder="请输入讲师简介"
                ></el-input>
              </el-form-item>
              <div class="operation">
                <el-button type="primary" @click="addteachersInfo()"
                  v-if="isAddShow(index)"
                >
                  <i class="el-icon-plus"></i>
                  添加讲师
                </el-button>
                <el-button
                  type="default"
                   v-if="(ruleForm.teachers.length>1)"
                  @click="delteachersInfo(index)"
                >
                  <i class="el-icon-minus"></i>删除讲师
                </el-button>
              </div>
            </div>
          </el-form-item>
        </el-row>

        <el-form-item label="课程提纲：" prop="course_outline">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 8}"
            v-model="ruleForm.course_outline"
          ></el-input>
        </el-form-item>

        <el-form-item label="常见问题：">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 8}"
            v-model="ruleForm.common_problem"
          ></el-input>
        </el-form-item>

        <!-- 商品信息和商家设置组件 -->
        <base-sell ref="clildren" :formData="formData" :isEdit="isEdit"></base-sell>

        <!-- 剪切组件 -->
        <my-cropper
          :isShow.sync="showCropper"
          :ratio="ratio"
          :cropperData="cropperData"
          @updateImg="cropUpdateImg"
        ></my-cropper>

        <el-form-item class="submit">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>


<script>
import Title from "../play-template/title";

import Sell from "../play-template/sell-style";

//课程创建接口
import { _courseAdd, _courseEdit } from "@/api/course";

//上传图片
import UploadCover from "@/components/upload-cover.vue";

//剪切组件
import myCropper from "@/components/my-cropper.vue";

import qs from "qs";

const _TEACHER_INFO = function() {
  return {
    teacher_name: "", //讲师名称列表
    teacher_title: "", //列表讲师标题
    teacher_introduction: "", //讲师简介列表
    teacher_pfrofile_photo:'' //讲师头像列表
  };
};

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    course_id: {
      type: String,
      default: ""
    },
    formData: {
      type: Object,
      default: {}
    },
    testData: {
      type: Object,
      default: {}
    }
  },
  components: {
    "base-title": Title,
    "base-sell": Sell,
    UploadCover,
    "my-cropper": myCropper
  },
  watch: {
    formData(val) {
      // console.log(this.formData);
      for (let i in this.ruleForm) {
        this.ruleForm[i] = this.formData[i];
      }
      if(this.formData&&((this.formData.live_state==1)||(this.formData.live_state==3))){
        this.live_state=true;
      }
    }
  },
  computed:{
  },
  data() {
    const teachers_info = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写讲师信息"));
      } else {
        callback();
      }
    };
    const started_at = (rule, value, callback) => {
      if (new Date(value) < new Date()) {
        callback(new Error("开始时间必须大于当前时间"));
      } else if (!value) {
        callback(new Error("请选择开始时间"));
      } else {
        callback();
      }
    };

    return {
      //剪切弹框
      showCropper: false,
      //获取点击的教师列表
      uploadImgIndex: "",
      // 剪裁数据
      cropperData: {
        url: "",
        index: ""
      },
      ratio: 100 / 100,
      options: [
        {
          value: 30,
          label: "0.5小时"
        },
        {
          value: 60,
          label: "1小时"
        },
        {
          value: 90,
          label: "1.5小时"
        },
        {
          value: 120,
          label: "2小时"
        },
        {
          value: 150,
          label: "2.5小时"
        },
        {
          value: 180,
          label: "3小时"
        }
      ],
      teachers_info: teachers_info,
      //是否可以直播禁止点击
      live_state:false,
      //绑定数据
      ruleForm: {
        course_mode: "1", //课程类型
        course_name: "", //课程名字
        times:'',//副标题
        started_at: "", //开始时间
        course_duration: "", //时长
        course_cover: "", //课程封面图片
        publicity_cover: "", //课程宣传封面
        card_cover: "", //课程生成卡片
        live_cover: "", //课程直播的卡片
        teachers: [
          {
            teacher_name: "", //讲师名称列表
            teacher_title: "", //列表讲师标题
            teacher_introduction: "", //讲师简介列表
            teacher_pfrofile_photo: "" //讲师头像列表
          }
        ],
        course_outline: "", //课程提纲
        common_problem: "" //常见问题
      },
      //表单验证
      rules: {
        course_name: [
          { required: true, message: "请输入课程名称", trigger: "blur" }
        ],
        times: [
          { required: true, message: "请输入课程副标题", trigger: "blur" }
        ],
        started_at: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change"
          }
        ],
        course_duration: [
          { required: true, message: "请输入直播时长", trigger: "blur" }
        ],
        course_outline: [
          { required: true, message: "请输入讲师提纲", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    //获取课程时长
    getDuration(val) {
      this.ruleForm.course_duration = val;
    },
    //添加教师信息
    addteachersInfo() {
      this.ruleForm.teachers.push(_TEACHER_INFO.call(this, 1));
    },
    //删除教师信息
    delteachersInfo(index) {
      this.ruleForm.teachers.splice(index, 1);
    },
    isAddShow(index){//是否添加教师信息的列表
        const teacher = this.ruleForm.teachers;
        if (!((index !== teacher.length - 1) || (teacher.length > 1))) {
            return true
          } else {
            return false
          }
    },
    uploadCourse(url) {
      this.ruleForm.course_cover = url;
    },
    uploadPub(url) {
      this.ruleForm.publicity_cover = url;
    },
    uploadCard(url) {
      this.ruleForm.card_cover = url;
    },
    uploadLive(url) {
      this.ruleForm.live_cover = url;
    },
    //教师上传头像的方法
    //获取点击的所在位置
    getImageIndex(index) {
      this.uploadImgIndex = index;
    },
    uploadWxBefore(file) {
      // if (file.size > 6 * 1024 * 1024) {
      //   this.$message.error("上传文件不能超过6MB");
      //   return false;
      // }
    },
    uploadWxError() {
      this.$message.error("上传失败");
    },
    uploadWxSuccess(response, file, fileList) {
      // console.log(response);
      //图片上传成功后的数据处理
      if (response.resultCode == 1) {
        this.ruleForm.teachers[this.uploadImgIndex].teacher_pfrofile_photo =
          response.result.url;
      } else {
        this.$message.error(response.errorMsg);
        return;
      }
    },
    PhotoCrop(index) {
      this.cropperData.url = this.ruleForm.teachers[
        index
      ].teacher_pfrofile_photo;
      this.cropperData.index = index;
      this.showCropper = true;
    },
    //剪切后返回数据
    cropUpdateImg(val) {
      // console.log(val);
      this.ruleForm.teachers[this.cropperData.index].teacher_pfrofile_photo =
        val.url;
    },
    PhotoDel(index) {
      this.ruleForm.teachers[index].teacher_pfrofile_photo = '';
    },
    //提交和编辑的方法统一
    courseSubmit(api, data) {
      //添加提交信息接口
      //加loading效果
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)"
      });
      var data = qs.stringify(data);
      api({
        data: data
      }).then(res => {
        loading.close();
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          // 操作成功后跳转列表页面
          setTimeout(() => {
            this.$router.push({ path: "/course/livelist" });
          }, 1000);
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    // 提交信息
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("父组件验证成功");
          let children = this.$refs.clildren;
          let res = this.$refs.clildren.submitForm("ruleForm");
          if (children.submitForm("ruleForm")) {
            console.log("子组件验证成功");
            let data = { ...this.ruleForm, ...children.ruleForm };
            if(data.course_mode==1){
              delete data.is_try;
            }
            if (this.isEdit) {
              data.course_id = this.course_id;
              this.courseSubmit(_courseEdit, data);
            } else {
              this.courseSubmit(_courseAdd, data);
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.live-form {
  padding: 20px;
  background: #ffffff;
  .info-content {
    .upload-image{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    max-width: 1000px;
    .submit {
      margin: 100px 0;
      width: 100%;
      display: flex;
      justify-content: center;
      button {
        width: 200px;
      }
    }
    .teachers-info {
      .teachers-wrapper {
        .operation {
          margin-top: 40px;
        }
      }
      .cover {
        margin-left: 120px;
        width: 220px;
        height: 120px;
        display: flex;
        margin-right: 20px;
        .img {
          height: 100px;
          width: 100px;
          overflow: hidden;
          position: relative;
          .img-shadow {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            display: none;
            justify-content: center;
            align-items: center;
            .deal-item {
              color: #ffffff;
              font-size: 16px;
              cursor: pointer;
              &:hover {
                color: #369ad1;
              }
              & + .deal-item {
                margin-left: 20px;
              }
            }
          }
          &:hover {
            .img-shadow {
              display: flex;
            }
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .upload-btn-wrap {
              width: 100px;
              height: 100px;
            .cover-box {
              width: 100px;
              height: 100px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              border: 1px dashed #dcdfe6;
              // border: 1px solid #dcdfe6;
              color: #999999;
              &:hover {
                color: #369ad1;
                border-color: #369ad1;
              }
            }
          }
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  translate: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.must-fill label::before {
  // display: inline-block;
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
